import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui";

interface MiniPagerProps {
  /** Zero-based. */
  index: number;
  total: number;
  onChange: (index: number) => void;
  className?: string;
}

/** Compact prev / "n of total" / next; PaginationSimple has no compact mode. */
export const MiniPager: React.FC<MiniPagerProps> = ({ index, total, onChange, className }) => (
  <div className={className ?? "flex items-center gap-1"}>
    <Button
      size="icon-xs"
      variant="ghost"
      aria-label="Previous"
      disabled={index <= 0}
      onClick={() => onChange(index - 1)}
    >
      <ChevronLeft />
    </Button>
    <span className="text-xs text-slate-500 tabular-nums">
      {index + 1} of {total}
    </span>
    <Button
      size="icon-xs"
      variant="ghost"
      aria-label="Next"
      disabled={index >= total - 1}
      onClick={() => onChange(index + 1)}
    >
      <ChevronRight />
    </Button>
  </div>
);
